import { AuctionBidsAPIUseCaseInterface } from 'application/usecases/AuctionBidsUseCase';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CardItem from './components/CardItem';
import { DetailAuctionBids } from './models/AuctionBids';

interface props {
    auctionBidsUseCase: AuctionBidsAPIUseCaseInterface;
}
const CU01402Page = ({ auctionBidsUseCase }: props) => {
    const dispatch = useAppDispatch();
    const { auctionId } = useParams();
    const [detailAuctionBids, setDetailAuctionBids] = useState<DetailAuctionBids>();
    useEffect(() => {
        (async () => {
            await [getAuctionBidsDetail({ auctionId: Number(auctionId) })];
        })();
    }, []);

    const getAuctionBidsDetail = async (params: { auctionId: number }) => {
        try {
            dispatch(startFetching());
            const response = await auctionBidsUseCase.getAuctionBidsDetail(params);
            if (response.result) {
                setDetailAuctionBids(response.result);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    return (
        <div className="cu-014-02-wrapper">
            <PageTitle title="落札" />
            <section className="center-inside">
                <CardItem data={detailAuctionBids} auctionBidsUseCase={auctionBidsUseCase} />
            </section>
        </div>
    );
};

export default CU01402Page;
